module.exports = __webpack_public_path__ + "img/icon-check.b5122d57.svg";